import React, { useEffect, useMemo, useRef, useState } from 'react';
import moment from 'moment';

const EIGHT_HOURS = 8 * 60 * 60;

const useShowCountDown = (event, countDownDisplayTimeout) => {
  const timeoutIdToShowCountDown = useRef(null);
  const hasTimeoutBeforeDisplay = useMemo(
    () => countDownDisplayTimeout
      && moment().add(countDownDisplayTimeout, 'seconds').isAfter(moment(event.startTime)),
    [countDownDisplayTimeout, event],
  );

  const [showCountDown, setShowCountDown] = useState(hasTimeoutBeforeDisplay);

  useEffect(() => {
    // show countdown
    if (countDownDisplayTimeout) {
      const timeToShowCounter = moment(event.startTime).subtract(
        countDownDisplayTimeout,
        'seconds',
      );
      const showCounterIn = timeToShowCounter.diff(moment(), 'seconds');

      if (timeoutIdToShowCountDown.current) {
        clearTimeout(timeoutIdToShowCountDown.current);
      }

      if (showCounterIn > 0 && showCounterIn < EIGHT_HOURS) {
        timeoutIdToShowCountDown.current = setTimeout(() => {
          setShowCountDown(true);
        }, showCounterIn * 1000);
      }

      return () => timeoutIdToShowCountDown.current && clearTimeout(timeoutIdToShowCountDown.current);
    }
  }, [countDownDisplayTimeout, event]);

  return showCountDown;
};

export default useShowCountDown;
